import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchSessionDetails } from "../services/paymentService"; // Import the service function

const CancelPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [sessionDetails, setSessionDetails] = useState(null); // State to store session details
  const [error, setError] = useState(null); // State to track errors
  const [loading, setLoading] = useState(true); // State to track loading
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const getSessionDetails = async () => {
      try {
        setLoading(true); // Start loading
        const data = await fetchSessionDetails(sessionId); // Use the service function
        setSessionDetails(data);
        setError(null); // Clear any previous errors
      } catch (error) {
        console.error(error.message);
        setError("Invalid URL. Please try again."); // Set error message
      } finally {
        setLoading(false); // Stop loading
      }
    };

    if (sessionId) {
      getSessionDetails();
    } else {
      setError("Invalid URL. Please try again."); // Set error message
      setLoading(false); // Stop loading if no session ID is provided
    }
  }, [sessionId]);

  const handleViewReport = () => {
    if (sessionDetails?.metadata?.emissionId) {
      navigate(`/calculator?emissionId=${sessionDetails.metadata.emissionId}`);
    }
  };

  const handleGoToCalculation = () => {
    navigate("/calculator"); // Navigate to the calculation page
  };

  return (
    <div className="container mt-5">
      {loading ? (
        // Show loading spinner while processing cancellation
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading...</p>
        </div>
      ) : error ? (
        // Show error message if session ID is invalid or missing
        <div>
          <p className="text-danger">{error}</p>
          <button className="btn btn-secondary mt-3" onClick={handleGoToCalculation}>
            Go to Calculation Page
          </button>
        </div>
      ) : (
        // Show cancellation message and session details if valid session ID
        <div>
          <h2>Payment Canceled</h2>
          <p>Your payment was canceled. You can try again if you'd like.</p>
          {sessionDetails && (
            <div>
              {/* <p>Session ID: {sessionDetails.id}</p> */}
              <p>Amount: ${(sessionDetails.amount_total / 100).toFixed(2)}</p>
              <p>Status: {sessionDetails.payment_status}</p>
            </div>
          )}
          <button className="btn btn-secondary mt-3" onClick={handleViewReport}>
            Go to Calculation Page & Try Again
          </button>
        </div>
      )}
    </div>
  );
};

export default CancelPage;